module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/404_DogCake-248ab0d2d1dd34ab0de308dbe86ad9d5.svg";